import React from "react"

export const IsolatedTimeIndicator = React.memo(({ position, isLoading = false }) => {
	if (position === null) return null

	const style = {
		opacity: 1,
		top: isLoading ? 70 : -15,
		height: isLoading ? "calc(100% - 70px)" : "101%",
		zIndex: 40,
		...(typeof position === "number" ? { left: `${position}px` } : { left: position })
	}

	return (
		<div className="absolute transition-opacity duration-300" style={style}>
			<div className="relative h-full">
				<div className="absolute inset-y-0 left-1/2 transform -translate-x-1/2 border-l-2 border-red-500"></div>
				<div className="w-3.5 h-3.5 bg-red-500 rounded-full absolute -top-1.5 left-1/2 transform -translate-x-1/2" />
			</div>
		</div>
	)
})
